/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BurnchainRewardListResponse,
    BurnchainRewardListResponseFromJSON,
    BurnchainRewardListResponseToJSON,
    BurnchainRewardSlotHolderListResponse,
    BurnchainRewardSlotHolderListResponseFromJSON,
    BurnchainRewardSlotHolderListResponseToJSON,
    BurnchainRewardsTotal,
    BurnchainRewardsTotalFromJSON,
    BurnchainRewardsTotalToJSON,
} from '../models';

export interface GetBurnchainRewardListRequest {
    limit?: number;
    offset?: number;
}

export interface GetBurnchainRewardListByAddressRequest {
    address: string;
    limit?: number;
    offset?: number;
}

export interface GetBurnchainRewardSlotHoldersRequest {
    limit?: number;
    offset?: number;
}

export interface GetBurnchainRewardSlotHoldersByAddressRequest {
    address: string;
    limit?: number;
    offset?: number;
}

export interface GetBurnchainRewardsTotalByAddressRequest {
    address: string;
}

/**
 * StackingRewardsApi - interface
 * 
 * @export
 * @interface StackingRewardsApiInterface
 */
export interface StackingRewardsApiInterface {
    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) reward recipients with the associated amounts and block info
     * @summary Get recent burnchain reward recipients
     * @param {number} [limit] max number of rewards to fetch
     * @param {number} [offset] index of first rewards to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StackingRewardsApiInterface
     */
    getBurnchainRewardListRaw(requestParameters: GetBurnchainRewardListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardListResponse>>;

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) reward recipients with the associated amounts and block info
     * Get recent burnchain reward recipients
     */
    getBurnchainRewardList(requestParameters: GetBurnchainRewardListRequest, initOverrides?: RequestInit): Promise<BurnchainRewardListResponse>;

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) rewards for the given recipient with the associated amounts and block info
     * @summary Get recent burnchain reward for the given recipient
     * @param {string} address Reward recipient address. Should either be in the native burnchain\&#39;s format (e.g. B58 for Bitcoin), or if a STX principal address is provided it will be encoded as into the equivalent burnchain format
     * @param {number} [limit] max number of rewards to fetch
     * @param {number} [offset] index of first rewards to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StackingRewardsApiInterface
     */
    getBurnchainRewardListByAddressRaw(requestParameters: GetBurnchainRewardListByAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardListResponse>>;

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) rewards for the given recipient with the associated amounts and block info
     * Get recent burnchain reward for the given recipient
     */
    getBurnchainRewardListByAddress(requestParameters: GetBurnchainRewardListByAddressRequest, initOverrides?: RequestInit): Promise<BurnchainRewardListResponse>;

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments.
     * @summary Get recent reward slot holders
     * @param {number} [limit] max number of items to fetch
     * @param {number} [offset] index of the first items to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StackingRewardsApiInterface
     */
    getBurnchainRewardSlotHoldersRaw(requestParameters: GetBurnchainRewardSlotHoldersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardSlotHolderListResponse>>;

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments.
     * Get recent reward slot holders
     */
    getBurnchainRewardSlotHolders(requestParameters: GetBurnchainRewardSlotHoldersRequest, initOverrides?: RequestInit): Promise<BurnchainRewardSlotHolderListResponse>;

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments for a given reward slot holder recipient address.
     * @summary Get recent reward slot holder entries for the given address
     * @param {string} address Reward slot holder recipient address. Should either be in the native burnchain\&#39;s format (e.g. B58 for Bitcoin), or if a STX principal address is provided it will be encoded as into the equivalent burnchain format
     * @param {number} [limit] max number of items to fetch
     * @param {number} [offset] index of the first items to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StackingRewardsApiInterface
     */
    getBurnchainRewardSlotHoldersByAddressRaw(requestParameters: GetBurnchainRewardSlotHoldersByAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardSlotHolderListResponse>>;

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments for a given reward slot holder recipient address.
     * Get recent reward slot holder entries for the given address
     */
    getBurnchainRewardSlotHoldersByAddress(requestParameters: GetBurnchainRewardSlotHoldersByAddressRequest, initOverrides?: RequestInit): Promise<BurnchainRewardSlotHolderListResponse>;

    /**
     * Retrieves the total burnchain (e.g. Bitcoin) rewards for a given recipient `address`
     * @summary Get total burnchain rewards for the given recipient
     * @param {string} address Reward recipient address. Should either be in the native burnchain\&#39;s format (e.g. B58 for Bitcoin), or if a STX principal address is provided it will be encoded as into the equivalent burnchain format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StackingRewardsApiInterface
     */
    getBurnchainRewardsTotalByAddressRaw(requestParameters: GetBurnchainRewardsTotalByAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardsTotal>>;

    /**
     * Retrieves the total burnchain (e.g. Bitcoin) rewards for a given recipient `address`
     * Get total burnchain rewards for the given recipient
     */
    getBurnchainRewardsTotalByAddress(requestParameters: GetBurnchainRewardsTotalByAddressRequest, initOverrides?: RequestInit): Promise<BurnchainRewardsTotal>;

}

/**
 * 
 */
export class StackingRewardsApi extends runtime.BaseAPI implements StackingRewardsApiInterface {

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) reward recipients with the associated amounts and block info
     * Get recent burnchain reward recipients
     */
    async getBurnchainRewardListRaw(requestParameters: GetBurnchainRewardListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/burnchain/rewards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BurnchainRewardListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) reward recipients with the associated amounts and block info
     * Get recent burnchain reward recipients
     */
    async getBurnchainRewardList(requestParameters: GetBurnchainRewardListRequest, initOverrides?: RequestInit): Promise<BurnchainRewardListResponse> {
        const response = await this.getBurnchainRewardListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) rewards for the given recipient with the associated amounts and block info
     * Get recent burnchain reward for the given recipient
     */
    async getBurnchainRewardListByAddressRaw(requestParameters: GetBurnchainRewardListByAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardListResponse>> {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling getBurnchainRewardListByAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/burnchain/rewards/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BurnchainRewardListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of recent burnchain (e.g. Bitcoin) rewards for the given recipient with the associated amounts and block info
     * Get recent burnchain reward for the given recipient
     */
    async getBurnchainRewardListByAddress(requestParameters: GetBurnchainRewardListByAddressRequest, initOverrides?: RequestInit): Promise<BurnchainRewardListResponse> {
        const response = await this.getBurnchainRewardListByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments.
     * Get recent reward slot holders
     */
    async getBurnchainRewardSlotHoldersRaw(requestParameters: GetBurnchainRewardSlotHoldersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardSlotHolderListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/burnchain/reward_slot_holders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BurnchainRewardSlotHolderListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments.
     * Get recent reward slot holders
     */
    async getBurnchainRewardSlotHolders(requestParameters: GetBurnchainRewardSlotHoldersRequest, initOverrides?: RequestInit): Promise<BurnchainRewardSlotHolderListResponse> {
        const response = await this.getBurnchainRewardSlotHoldersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments for a given reward slot holder recipient address.
     * Get recent reward slot holder entries for the given address
     */
    async getBurnchainRewardSlotHoldersByAddressRaw(requestParameters: GetBurnchainRewardSlotHoldersByAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardSlotHolderListResponse>> {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling getBurnchainRewardSlotHoldersByAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/burnchain/reward_slot_holders/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BurnchainRewardSlotHolderListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of the Bitcoin addresses that would validly receive Proof-of-Transfer commitments for a given reward slot holder recipient address.
     * Get recent reward slot holder entries for the given address
     */
    async getBurnchainRewardSlotHoldersByAddress(requestParameters: GetBurnchainRewardSlotHoldersByAddressRequest, initOverrides?: RequestInit): Promise<BurnchainRewardSlotHolderListResponse> {
        const response = await this.getBurnchainRewardSlotHoldersByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the total burnchain (e.g. Bitcoin) rewards for a given recipient `address`
     * Get total burnchain rewards for the given recipient
     */
    async getBurnchainRewardsTotalByAddressRaw(requestParameters: GetBurnchainRewardsTotalByAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BurnchainRewardsTotal>> {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling getBurnchainRewardsTotalByAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/burnchain/rewards/{address}/total`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BurnchainRewardsTotalFromJSON(jsonValue));
    }

    /**
     * Retrieves the total burnchain (e.g. Bitcoin) rewards for a given recipient `address`
     * Get total burnchain rewards for the given recipient
     */
    async getBurnchainRewardsTotalByAddress(requestParameters: GetBurnchainRewardsTotalByAddressRequest, initOverrides?: RequestInit): Promise<BurnchainRewardsTotal> {
        const response = await this.getBurnchainRewardsTotalByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
